<template>
    <div>
    <transition
            enter-active-class="transition duration-400 ease-in"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-100 ease-out"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
            class="h-full"
        >
        </transition>
        <div class="flex h-[85vh] flex-col space-y-10">
            <div class="w-full px-1 pt-1 pr-2 fixed bg-neutral-200 flex flex-col">
                <div class="w-full h-10 bg-neutral-50 flex items-center justify-between shadow-md rounded m-1 space-x-4">
                    <div class="flex items-center space-x-4 justify-self-start pl-2">
                        <div class="w-fit">
                            <PaginationLoader
                                class="rounded-full hover:bg-gray-300"
                                @refetch-results="loadClients"
                                :isLoading="isLoading"
                              ></PaginationLoader>
                        </div>
                    <!-- <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Client:
                            </div>
                        </div>
                        <select v-model="clientId" class="bg-gray-50 p-1 h-3/4 rounded-r border-2 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="">
                            <option :value="null">------</option>    
                            <option v-for="client in clients" :key="client.id" :value="client.id">{{ client.client_name }}</option>
                        </select>
                    </div> -->
                    <!-- <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Responsible:
                            </div>
                        </div>
                        <select v-model="userId" class="bg-gray-50 p-1 h-3/4 rounded-r border-2 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="">
                            <option :value="null">------</option>    
                            <option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
                        </select>
                    </div> -->
                    <!-- <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Next Step:
                            </div>
                        </div>
                        <select v-model="nextStepId" class="bg-gray-50 p-1 h-3/4 rounded-r border-2 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="">
                            <option :value="null">------</option>    
                            <option v-for="crmDetail in crmDetailTypes" :key="crmDetail.id" :value="crmDetail.id">{{ crmDetail.unresolved_label }}</option>
                        </select>
                    </div> -->
                    <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Due Date:
                            </div>
                        </div>
                        <div class="bg-gray-50 p-1 flex items-center rounded-r border-2">
                            <input type="date" @change="setDueDate" :value="dueDate" class="bg-gray-50  text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="" />
                            <input class="ml-1" @input="setDueThisWeek" v-model="thisWeek" :value="true" type="checkbox">
                            <div class="flex ml-1 items-center">
                                This Week
                            </div>
                        </div>
                    </div>
                    <!-- <div class="card flex justify-center">
                        <Button type="button" pt:root="hover:bg-gray-300 rounded-md hover:cursor-pointer p-1" :unstyled="true" @click="toggle"><BulkOperationSVG /></Button>

                        <Popover ref="op">
                            <div class="grid p-2 grid-cols-2 gap-2">
                                <base-button @click="setBulkAction('responsible')" >
                                    Edit Next Step Responsible
                                </base-button>
                                <base-button @click="setBulkAction('details')" >
                                    Edit Next Step Details
                                </base-button>
                            </div>
                            <base-dialog-box v-if="bulkAction" @close="clearBulkAction">
                                <template #header>
                                <h2>Bulk Action: {{ bulkAction.title }}</h2>
                                </template>
                                <template #body>
                                <CrmDetailSpreadsheetBulkOps
                                    :bulk-action="bulkAction"
                                    :selected-results="selectedDetails"
                                    :user-options="userOptions"
                                    @close-bulk-operation="clearBulkAction"
                                    @refetch-results="loadCompanies"
                                ></CrmDetailSpreadsheetBulkOps>
                                </template>
                            </base-dialog-box>
                        </Popover>
                    </div> -->
                    <!-- <div
                        class="rounded-md hover:bg-gray-300 p-1 hover:cursor-pointer"
                        ref="bulkOperationsBoundary"
                        title="Bulk Operations"
                        @click="toggleShowBulkOperations"
                    >
                        <BulkOperationSVG />
                    </div> -->
                    </div>
                </div>
            </div>
            <div v-if="clients" class="p-4 w-full h-full overflow-auto">
                <base-table>
                    <template #table-header>
                    <base-table-header :key="header.value" :header="header.value" class="-top-1.5" :class="header.class" v-for="header in tableHeadersList">
                      <div class="flex items-center justify-between space-x-1">
                        <div>
                          {{ header.value }}
                        </div>
                      </div>
                    </base-table-header>
                    </template>
                    <template #table-body>
                        <ClientTaskSpreadsheetRow v-for="client in filteredClients" :selected-tasks="selectedTasks" :key="client.id" :client-task-types="clientTaskTypes" :user-options="userOptions" :client="client" @refetch-clients="loadClients"/>
                    </template>
                </base-table>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import { getAllClients } from '@/services/Client';
import { getClientTaskTypes } from '@/services/ClientTaskTypes';
import { useToast } from 'vue-toast-notification';
import PaginationLoader from '../base-components/PaginationLoader.vue';
import ClientTaskSpreadsheetRow from './ClientTaskSpreadsheetRow.vue';
import { getUsers } from '@/services/User';
import { getTodaysDateAsString } from '@/composables/formatDate';
// import { createUserInteractionLog } from '@/services/UserInteractionLog';
import BulkOperationSVG from '../svg-components/BulkOperationSVG.vue';
import { Button, Popover } from 'primevue';
// import CrmDetailSpreadsheetBulkOps from './CrmDetailSpreadsheetBulkOps.vue';


const store = useStore()
const $toast = useToast()
const isLoading = ref(false)
const clientTaskTypes = ref([])
const taskId = ref(null)
const dueDate = ref(null)
const clients = ref([])
const userOptions = ref([])
const changesList = ref([])
const selectedTasks = ref([])
const savingChanges = ref(false)
const showActiveOnly = ref(true)

async function loadTaskTypes() {
    const token = store.state.auth.token
    const response = await getClientTaskTypes(token)
    // console.log('response', response.data)
    clientTaskTypes.value = response.data
}

const op = ref();

const toggle = (event) => {
    op.value.toggle(event);
}

async function loadClients() {
    isLoading.value = true
    const result = await getAllClients({ token: store.state.auth.token });
    clients.value = result.data;
    isLoading.value = false
}


const selectedTasksLength = computed(() => {
    return selectedTasks.value.length
})

// const clientTaskSpreadsheetBulkOperations = computed(() => {return {
//     editResponsible: {
//         label: 'Edit Next Step Responsible',
//         modelPath: 'client_tasks',
//         endpoint: 'bulk_update_crm_detail_user',
//         message: `Please select the user to assign as responsible for the next step for the ${selectedTasksLength.value} selected companies.`
//     },
//     editNextStepDetails: {
//         label: 'Edit Next Step Details',
//         modelPath: 'crm_details',
//         endpoint: 'bulk_update_crm_detail_notes',
//         message: `Please add the next step detail for the ${selectedTasksLength.value} selected companies.`,
//     }
// }
// })


async function setDueDate(event) {
    dueDate.value = event.target.value
}

// function addSelectedDetail(detailId){
//     const crmDetail = selectedDetails.value.find((id) => id == detailId)
//     if(!crmDetail){
//         selectedDetails.value.push(detailId)
//     }
// }

// function removeSelectedDetail(detailId){
//     const crmDetailIndex = selectedDetails.value.findIndex((id) => id === detailId)
//     if(crmDetailIndex != -1){
//         selectedDetails.value.splice(crmDetailIndex, 1)
//     }
// }
const showBulkOperations = ref(false)

function toggleShowBulkOperations(){
    showBulkOperations.value = !showBulkOperations.value
}

// function setBulkAction(action){
//     if(selectedDetails.value.length > 0){
//         if(action === 'responsible'){
//             bulkAction.value = crmDetailSpreadsheetBulkOperations.value.editResponsible
//         }
//         if(action === 'details'){
//             bulkAction.value = crmDetailSpreadsheetBulkOperations.value.editNextStepDetails
//         }
//     }

// }

const tableHeadersList = ref([
    // {value: '', class: "w-10"},
    {value: 'Client', class: ""},
    {value: 'Coverage', class: ""},
    {value: 'Next Task', class: ""},
    {value: 'Due Date', class: ""},
    {value: 'Next Task Detail', class: "w-screen"},
    {value: 'Responsible', class: ""},
])


function sortByDueDate(a, b){
    if(a.due_date && b.due_date){
        if(a.due_date == b.due_date){
            return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
        } else {
            return new Date(a.due_date) - new Date(b.due_date)
        }
    } else if ((a.due_date && !b.due_date)){
        return 1
    } else if ((b.due_date && !a.due_date)){
        return -1
    } else {
        return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
    }
}

function getClientNextTask(client){
    if(client.tasks.length > 0){
        let openTasks = client.tasks.filter((task) => {
            return !task.resolved_date
        })
        if(openTasks.length > 0){
            openTasks = openTasks.sort(sortByDueDate)
            return openTasks[0]
        } else {
            return null
        }
    } else {
        return null
    }
}

const bulkAction = ref(null)

function clearBulkAction(){
    bulkAction.value = null
}

function getSunday(d) {
  d = new Date(d);
  let day = d.getDay(),
    diff = d.getDate() - day
  return new Date(d.setDate(diff));
}

function getStaturday(d) {
  d = new Date(d);
  let day = d.getDay(),
    diff = d.getDate() - day + 6
  return new Date(d.setDate(diff));
}

const filteredClients = computed(() => {
    let filterClients = clients.value
    if(dueDate.value){
        filterClients = filterClients.filter((client) => {
            const nextTask = getClientNextTask(client)
            if(nextTask){
                return nextTask.due_date && nextTask.due_date == dueDate.value
            } else {
                return false
            }
        })
    }
    if(thisWeek.value){
        let today = new Date()
        let sunday = getSunday(today)
        let saturday = getStaturday(today)
        filterClients = filterClients.filter((client) => {
            const nextTask = getClientNextTask(client)
            if(nextTask){
                return nextTask.due_date && new Date(nextTask.due_date) >= sunday && new Date(nextTask.due_date) <= saturday
            } else {
                return false
            }
        })
        
    }
    return filterClients
})

// const filteredClients = computed(() => {
//     let filterCompanies = companies.value
//     if(userId.value){
//         filterCompanies = filterCompanies.filter((company) => {
//             const nextAction = getCompanyNextAction(company)
//             if(nextAction){
//                 return nextAction.user && nextAction.user.id == userId.value
//             } else {
//                 return false
//             }
//         })
//     }
//     if(nextStepId.value){
//         filterCompanies = filterCompanies.filter((company) => {
//             const nextAction = getCompanyNextAction(company)
//             if(nextAction){
//                 return nextAction.action && nextAction.action.id == nextStepId.value
//             } else {
//                 return false
//             }
//         })
//     }
//     if(dueDate.value){
//         filterCompanies = filterCompanies.filter((company) => {
//             const nextAction = getCompanyNextAction(company)
//             if(nextAction){
//                 return nextAction.due_date && nextAction.due_date == dueDate.value
//             } else {
//                 return false
//             }
//         })
//     }
//     if(thisWeek.value){
//         let today = new Date()
//         let sunday = getSunday(today)
//         let saturday = getStaturday(today)
//         filterCompanies = filterCompanies.filter((company) => {
//             const nextAction = getCompanyNextAction(company)
//             if(nextAction){
//                 return nextAction.due_date && new Date(nextAction.due_date) >= sunday && new Date(nextAction.due_date) <= saturday
//             } else {
//                 return false
//             }
//         })
        
//     }
//     return filterCompanies
// })

// async function loadCompanies(){
//     const token = store.state.auth.token
//     let queryParams = `show_on_crm_spreadsheet_view=True`
//     // let queryParams = ''
//     // if(crmStatus.value){
//     //     queryParams += `&crm_status=${crmStatus.value}`
//     // }
//     if(clientId.value){
//         queryParams += `&client_drf=${clientId.value}`
//     }
//     isLoading.value = true
//     const result = await getCrmSpreadsheetCompanies(token, queryParams)
//     // console.log('result', result)
//     if(result.status == 200){
//         companies.value = result.data.companies
//         isLoading.value = false
//         actionsToAdd.value = []
//         actionsToUpdate.value = []
//         selectedDetails.value = []
//         companiesToUpdate.value = []
//         isLoading.value = false
//     }
// }

const thisWeek = ref(false)

async function setDueThisWeek(){
    thisWeek.value = !thisWeek.value

}

watch(thisWeek, () => {
    if(thisWeek.value){
        dueDate.value = null
    }
})

watch(dueDate, () => {
    if(dueDate.value){
        thisWeek.value = false
    }
})


async function setUserOptions() {
    let payload = {
        token: store.state.auth.token,
        endpoint: '?group_id=1&group_id=7&group_id=8&exclude_dev=True&is_active=True'
    }
    const result = await getUsers(payload)
    userOptions.value = result.users
}

loadTaskTypes()
setUserOptions()
loadClients()

</script>